export const SOLCHICK_TOKEN_ADDRESS_ON_SOL = process.env
  .REACT_APP_SOLCHICK_TOKEN_ADDRESS_ON_SOL as string;

export const SOLCHICK_DECIMALS_ON_SOL: number = parseInt(
  process.env.REACT_APP_SOLCHICK_DECIMALS as string,
  10,
);

const URL_BACKEND_BASE = process.env.REACT_APP_BACKEND_URL as string;

const CLAIM_PROGRAM_ID = 'J9MBPg5Qugrm1FPf4PVdifcpidRkSmP1cy7cu3iYsk8F';
const CLAIM_PROGRAM_ID_DEV = '6BCXPkWFgKoHVwAiojyuMni6MaK8va6Pzgtyd43ZM3DG';
export const CGC_TOKEN_CLAIM_PROGRAM_ID =
  process.env.REACT_APP_CLUSTER === 'mainnet'
    ? CLAIM_PROGRAM_ID
    : CLAIM_PROGRAM_ID_DEV;

const VAULT_WALLET = '6KMsuFVPtTe7kT4QuPzbftUCNDggZ7ftbB5WNoBN9djq';
const VAULT_WALLET_DEV = '5hW2Y4KGNuo8Bh6ReD2D8VT3TTcBZSsxxJmnunvRmWc9';

export const TOKEN_VAULT_WALLET =
  process.env.REACT_APP_CLUSTER === 'mainnet' ? VAULT_WALLET : VAULT_WALLET_DEV;

export const URL_CLAIM_HISTORY = (address: string) =>
  `${URL_BACKEND_BASE}/api/user_history?address=${address}`;

export const URL_CLAIM_INFO = (address: string) =>
  `${URL_BACKEND_BASE}/api/user_info?address=${address}`;

export const URL_CLAIM_INFO_V2 = (address: string) =>
  `${URL_BACKEND_BASE}/api/user_info_v2?address=${address}`;

export const URL_SERVER_INFO = () => `${URL_BACKEND_BASE}/api/status`;

export const URL_SUBMIT_CLAIM = (
  address: string,
  txId: string,
  distributor: string,
  index: string | number,
) =>
  `${URL_BACKEND_BASE}/api/claim?address=${address}&tx_id=${txId}&distributor=${distributor}&index=${index}`;
